import {DataManagementModulePermissionCodes} from 'utils/types';
import {defineTabDef} from 'utils/helpers';

export const dataLoadingTabs = defineTabDef({
  upload: {
    tabName: 'upload',
    tabTitle: 'Upload Sales Data',
    requiredAnyPermission: [DataManagementModulePermissionCodes.view_upload_sales_data],
  },
  'upload-pre-sales': {
    tabName: 'upload-pre-sales',
    tabTitle: 'Upload Pre-Sales Data',
    requiredAnyPermission: [DataManagementModulePermissionCodes.view_upload_pre_sales_data],
  },
  'upload-rfp': {
    tabName: 'upload-rfp',
    tabTitle: 'Upload RFP Data',
    requiredAnyPermission: [DataManagementModulePermissionCodes.view_upload_rfp_data],
  },
  'upload-media': {
    tabName: 'upload-media',
    tabTitle: 'Upload Media Data',
    requiredAnyPermission: [DataManagementModulePermissionCodes.view_upload_media_data],
  },
} as const);
